export function clearLocalStorage() {
  let sqljs_dbKey = localStorage.getItem("sqljs_db");
  const isOffLine = localStorage.getItem("isOffLine");
  const uulimsValue = localStorage.getItem("UULIMS"); // Save UULIMS value
  localStorage.clear();                               // Clear all localStorage
  if (sqljs_dbKey) {
    localStorage.setItem("isOffLine", isOffLine);
    localStorage.setItem("sqljs_db", sqljs_dbKey);
  }
  sessionStorage.setItem("isLoggedIn", true);
  if (uulimsValue !== null) {
    localStorage.setItem("UULIMS", uulimsValue);      // Restore UULIMS if it existed
  }
}
